import type { ReactNode } from 'react'
import type { UserSession } from '../types/user-session.type'

import { useQuery } from '@tanstack/react-query'
import { createContext } from 'react'
import { userApi } from '../apis/users.api'
import { getResearchSettings } from '../utils/user-session-storage.util'

export const SessionContext = createContext<{
  session: UserSession | null
}>({
  session: null,
})

type Props = {
  children: ReactNode
}

export function SessionProvider({ children }: Props) {
  const { accountId, ...remainSettings } = getResearchSettings()
  const { memberId, name } = remainSettings
  const { createUserSession } = userApi()

  const { data: userSession } = useQuery({
    queryKey: ['get-user-session', accountId, memberId, name],
    queryFn: () => {
      return createUserSession(remainSettings)
    },
    enabled: !!accountId,
    refetchOnWindowFocus: false,
    retry: 1,
  })

  return (
    <>
      {userSession && (
        <SessionContext.Provider value={{ session: userSession }}>
          {children}
        </SessionContext.Provider>
      )}
    </>
  )
}
